var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaylist(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.974 22.8683V13.6302C27.974 8.60189 27.974 6.08774 26.4118 4.52564C24.8498 2.96354 22.3356 2.96354 17.3073 2.96354H15.974C10.9457 2.96354 8.43151 2.96354 6.86941 4.52564C5.30731 6.08774 5.30731 8.60189 5.30731 13.6302V26.2969",
    stroke: "#808191",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.974 22.9635H8.64065C6.7997 22.9635 5.30731 24.4559 5.30731 26.2969C5.30731 28.1378 6.7997 29.6302 8.64065 29.6302H27.974",
    stroke: "#808191",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.974 22.9635C26.133 22.9635 24.6406 24.4559 24.6406 26.2969C24.6406 28.1378 26.133 29.6302 27.974 29.6302",
    stroke: "#808191",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5885 13.4147C20.4203 14.131 19.6248 14.6371 18.0339 15.6494C16.4959 16.6281 15.7269 17.1173 15.1072 16.9206C14.8511 16.8393 14.6176 16.6849 14.4293 16.4722C13.974 15.9577 13.974 14.9595 13.974 12.9635C13.974 10.9675 13.974 9.96946 14.4293 9.45491C14.6176 9.24218 14.8511 9.08774 15.1072 9.00643C15.7269 8.80975 16.4959 9.29905 18.0339 10.2776C19.6248 11.2899 20.4203 11.7961 20.5885 12.5124C20.658 12.808 20.658 13.1191 20.5885 13.4147Z",
    stroke: "#808191",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaylist);
export default __webpack_public_path__ + "static/media/playlist.55da04629cd927d69a34ef36f9a6af32.svg";
export { ForwardRef as ReactComponent };